// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c4140025","513":"3d19befe","703":"583fb6f1","787":"a204c241"}[chunkId] + ".chunk.js";
};